"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useGetUserContextQuery = useGetUserContextQuery;
exports.useGetUserContextLazyQuery = useGetUserContextLazyQuery;
exports.useUpdateUserAttributeMutation = useUpdateUserAttributeMutation;
exports.UpdateUserAttributeDocument = exports.GetUserContextDocument = exports.EnclaveType = exports.LogFilterKind = exports.LogFilterOperator = exports.TokenAccessLevel = exports.OutagesType = exports.ApmSummaryMeasurementType = exports.ApmSummaryField = exports.VolumetricsResolution = exports.VolumetricsMeasurementType = exports.VolumetricsField = exports.AttributeType = exports.ProductContext = exports.LogProduct = exports.Product = exports.GroupMappingType = exports.SamlOrganizationMapping = exports.ProductRole = exports.OrganizationRole = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));

var Apollo = _interopRequireWildcard(require("@apollo/client"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    mutation updateUserAttribute($id: String!, $value: String!) {\n  updateUserAttribute(input: {id: $id, value: $value}) {\n    userAttribute {\n      ... on AttributeJson {\n        id\n        value\n      }\n    }\n  }\n}\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    query getUserContext($navUiStateKey: String!) {\n  user {\n    id\n    firstName\n    lastName\n    email\n    navUiState: userAttribute(id: $navUiStateKey) {\n      ... on AttributeJson {\n        value\n      }\n    }\n    currentOrganization {\n      id\n      name\n      role\n      products {\n        id\n        name\n        activated\n        productRole\n      }\n    }\n    organizations {\n      id\n      name\n      products {\n        id\n        name\n        activated\n        productRole\n      }\n    }\n  }\n}\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var OrganizationRole;
exports.OrganizationRole = OrganizationRole;

(function (OrganizationRole) {
  OrganizationRole["Owner"] = "OWNER";
  OrganizationRole["Admin"] = "ADMIN";
  OrganizationRole["Member"] = "MEMBER";
  OrganizationRole["Billing"] = "BILLING";
  OrganizationRole["RestrictedMember"] = "RESTRICTED_MEMBER";
})(OrganizationRole || (exports.OrganizationRole = OrganizationRole = {}));

var ProductRole;
exports.ProductRole = ProductRole;

(function (ProductRole) {
  ProductRole["Owner"] = "OWNER";
  ProductRole["Admin"] = "ADMIN";
  ProductRole["Editor"] = "EDITOR";
  ProductRole["Member"] = "MEMBER";
  ProductRole["Viewer"] = "VIEWER";
  ProductRole["ReadOnly"] = "READ_ONLY";
  ProductRole["Contact"] = "CONTACT";
  ProductRole["NoAccess"] = "NO_ACCESS";
  ProductRole["RmAll"] = "RM_ALL";
  ProductRole["RwAll"] = "RW_ALL";
  ProductRole["RoAll"] = "RO_ALL";
  ProductRole["RwFew"] = "RW_FEW";
  ProductRole["RoFew"] = "RO_FEW";
  ProductRole["RmAllPay"] = "RM_ALL_PAY";
  ProductRole["RwAllPay"] = "RW_ALL_PAY";
  ProductRole["RwFewPay"] = "RW_FEW_PAY";
  ProductRole["RoAllPay"] = "RO_ALL_PAY";
  ProductRole["RoFewPay"] = "RO_FEW_PAY";
})(ProductRole || (exports.ProductRole = ProductRole = {}));

var SamlOrganizationMapping;
exports.SamlOrganizationMapping = SamlOrganizationMapping;

(function (SamlOrganizationMapping) {
  SamlOrganizationMapping["Mapping"] = "MAPPING";
})(SamlOrganizationMapping || (exports.SamlOrganizationMapping = SamlOrganizationMapping = {}));

var GroupMappingType;
exports.GroupMappingType = GroupMappingType;

(function (GroupMappingType) {
  GroupMappingType["Organization"] = "ORGANIZATION";
  GroupMappingType["Product"] = "PRODUCT";
})(GroupMappingType || (exports.GroupMappingType = GroupMappingType = {}));

var Product;
exports.Product = Product;

(function (Product) {
  Product["Appoptics"] = "APPOPTICS";
  Product["Loggly"] = "LOGGLY";
  Product["Pingdom"] = "PINGDOM";
  Product["Papertrail"] = "PAPERTRAIL";
})(Product || (exports.Product = Product = {}));

var LogProduct;
exports.LogProduct = LogProduct;

(function (LogProduct) {
  LogProduct["Loggly"] = "LOGGLY";
  LogProduct["Papertrail"] = "PAPERTRAIL";
})(LogProduct || (exports.LogProduct = LogProduct = {}));

var ProductContext;
exports.ProductContext = ProductContext;

(function (ProductContext) {
  ProductContext["Appoptics"] = "APPOPTICS";
  ProductContext["Loggly"] = "LOGGLY";
  ProductContext["Pingdom"] = "PINGDOM";
  ProductContext["Papertrail"] = "PAPERTRAIL";
  ProductContext["InfrastructureMonitor"] = "INFRASTRUCTURE_MONITOR";
})(ProductContext || (exports.ProductContext = ProductContext = {}));

var AttributeType;
exports.AttributeType = AttributeType;

(function (AttributeType) {
  AttributeType["String"] = "STRING";
  AttributeType["Int"] = "INT";
  AttributeType["Float"] = "FLOAT";
  AttributeType["Bool"] = "BOOL";
  AttributeType["Json"] = "JSON";
})(AttributeType || (exports.AttributeType = AttributeType = {}));

var VolumetricsField;
exports.VolumetricsField = VolumetricsField;

(function (VolumetricsField) {
  VolumetricsField["Host"] = "HOST";
  VolumetricsField["Tag"] = "TAG";
  VolumetricsField["App"] = "APP";
  VolumetricsField["Pipeline"] = "PIPELINE";
  VolumetricsField["Product"] = "PRODUCT";
})(VolumetricsField || (exports.VolumetricsField = VolumetricsField = {}));

var VolumetricsMeasurementType;
exports.VolumetricsMeasurementType = VolumetricsMeasurementType;

(function (VolumetricsMeasurementType) {
  VolumetricsMeasurementType["Count"] = "COUNT";
  VolumetricsMeasurementType["VolumeBytes"] = "VOLUME_BYTES";
})(VolumetricsMeasurementType || (exports.VolumetricsMeasurementType = VolumetricsMeasurementType = {}));

var VolumetricsResolution;
exports.VolumetricsResolution = VolumetricsResolution;

(function (VolumetricsResolution) {
  VolumetricsResolution["Auto"] = "AUTO";
})(VolumetricsResolution || (exports.VolumetricsResolution = VolumetricsResolution = {}));

var ApmSummaryField;
exports.ApmSummaryField = ApmSummaryField;

(function (ApmSummaryField) {
  ApmSummaryField["Service"] = "SERVICE";
  ApmSummaryField["Host"] = "HOST";
})(ApmSummaryField || (exports.ApmSummaryField = ApmSummaryField = {}));

var ApmSummaryMeasurementType;
exports.ApmSummaryMeasurementType = ApmSummaryMeasurementType;

(function (ApmSummaryMeasurementType) {
  ApmSummaryMeasurementType["CpuUtilization"] = "CPU_UTILIZATION";
  ApmSummaryMeasurementType["MemoryUtilization"] = "MEMORY_UTILIZATION";
  ApmSummaryMeasurementType["ResponseTime"] = "RESPONSE_TIME";
  ApmSummaryMeasurementType["RequestVolume"] = "REQUEST_VOLUME";
  ApmSummaryMeasurementType["ErrorRate"] = "ERROR_RATE";
  ApmSummaryMeasurementType["HostsCount"] = "HOSTS_COUNT";
})(ApmSummaryMeasurementType || (exports.ApmSummaryMeasurementType = ApmSummaryMeasurementType = {}));

var OutagesType;
exports.OutagesType = OutagesType;

(function (OutagesType) {
  OutagesType["Uptime"] = "UPTIME";
  OutagesType["Transaction"] = "TRANSACTION";
})(OutagesType || (exports.OutagesType = OutagesType = {}));

var TokenAccessLevel;
exports.TokenAccessLevel = TokenAccessLevel;

(function (TokenAccessLevel) {
  TokenAccessLevel["Record"] = "RECORD";
  TokenAccessLevel["Read"] = "READ";
  TokenAccessLevel["Full"] = "FULL";
})(TokenAccessLevel || (exports.TokenAccessLevel = TokenAccessLevel = {}));

var LogFilterOperator;
exports.LogFilterOperator = LogFilterOperator;

(function (LogFilterOperator) {
  LogFilterOperator["Contains"] = "CONTAINS";
  LogFilterOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
})(LogFilterOperator || (exports.LogFilterOperator = LogFilterOperator = {}));

var LogFilterKind;
exports.LogFilterKind = LogFilterKind;

(function (LogFilterKind) {
  LogFilterKind["Regex"] = "REGEX";
  LogFilterKind["String"] = "STRING";
})(LogFilterKind || (exports.LogFilterKind = LogFilterKind = {}));

var EnclaveType;
exports.EnclaveType = EnclaveType;

(function (EnclaveType) {
  EnclaveType["Angular"] = "ANGULAR";
  EnclaveType["Angularjs"] = "ANGULARJS";
  EnclaveType["Webform"] = "WEBFORM";
  EnclaveType["Swicus"] = "SWICUS";
})(EnclaveType || (exports.EnclaveType = EnclaveType = {}));

var GetUserContextDocument = (0, Apollo.gql)(_templateObject());
/**
 * __useGetUserContextQuery__
 *
 * To run a query within a React component, call `useGetUserContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContextQuery({
 *   variables: {
 *      navUiStateKey: // value for 'navUiStateKey'
 *   },
 * });
 */

exports.GetUserContextDocument = GetUserContextDocument;

function useGetUserContextQuery(baseOptions) {
  return Apollo.useQuery(GetUserContextDocument, baseOptions);
}

function useGetUserContextLazyQuery(baseOptions) {
  return Apollo.useLazyQuery(GetUserContextDocument, baseOptions);
}

var UpdateUserAttributeDocument = (0, Apollo.gql)(_templateObject2());
exports.UpdateUserAttributeDocument = UpdateUserAttributeDocument;

/**
 * __useUpdateUserAttributeMutation__
 *
 * To run a mutation, you first call `useUpdateUserAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAttributeMutation, { data, loading, error }] = useUpdateUserAttributeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
function useUpdateUserAttributeMutation(baseOptions) {
  return Apollo.useMutation(UpdateUserAttributeDocument, baseOptions);
}